<template>
  <div
    class="border-static-default-low rounded-lg mt-12 flex flex-col flex-wrap gap-2 border p-16 first:mt-0 md:flex-row md:items-center md:justify-between"
  >
    <div class="flex items-center gap-4">
      <component :is="icon" v-if="icon" size="32" />
      <h3 class="heading-3">{{ title }}</h3>
    </div>

    <InteractiveRating v-model="rate" :name="id" />
  </div>

  <p v-if="!!errorMessage" class="text-static-danger-hi mt-8">
    {{ errorMessage }}
  </p>
</template>

<script setup lang="ts">
import type { Component, Raw } from 'vue'

import InteractiveRating from '../InteractiveRating/InteractiveRating.vue'

defineProps<{
  id: string
  title: string
  icon?: Raw<Component> | string
  errorMessage?: string
}>()

const rate = defineModel<number>()

defineEmits<{
  (e: 'update:modelValue', rate: number): void
}>()
</script>
